module.exports = __webpack_public_path__ + "img/ResourcePopulationHover_ua.8415b67d.webp";